export const GEO_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

export function coordinateFor(location) {
  if (location === null || location === undefined) return null;
  const raw = location.coordinates;
  const longitude = Array.isArray(raw) ? Number(raw[0]) : Number(raw?.longitude);
  const latitude = Array.isArray(raw) ? Number(raw[1]) : Number(raw?.latitude);
  if (!Number.isFinite(longitude) || longitude < -180 || longitude > 180
      || !Number.isFinite(latitude) || latitude < -90 || latitude > 90) return null;
  return [longitude, latitude];
}

export function mapView(points) {
  if (points.length === 0) return { center: [18, 34], zoom: 1 };
  const longitudes = points.map((point) => point.coordinates[0]);
  const latitudes = points.map((point) => point.coordinates[1]);
  const longitudeSpan = Math.max(...longitudes) - Math.min(...longitudes);
  const latitudeSpan = Math.max(...latitudes) - Math.min(...latitudes);
  const span = Math.max(longitudeSpan, latitudeSpan * 1.7);
  let zoom = 1.15;
  if (span < 4) zoom = 6;
  else if (span < 15) zoom = 3.8;
  else if (span < 45) zoom = 2.35;
  else if (span < 95) zoom = 1.55;
  return {
    center: [
      (Math.min(...longitudes) + Math.max(...longitudes)) / 2,
      (Math.min(...latitudes) + Math.max(...latitudes)) / 2,
    ],
    zoom,
  };
}

export function sameCoordinates(from, to) {
  return Math.abs(from[0] - to[0]) < 0.000001
    && Math.abs(from[1] - to[1]) < 0.000001;
}

export function curvedRoute(from, to) {
  let longitudeDelta = to[0] - from[0];
  if (longitudeDelta > 180) longitudeDelta -= 360;
  if (longitudeDelta < -180) longitudeDelta += 360;
  const latitudeDelta = to[1] - from[1];
  const latitudeScale = Math.max(0.2, Math.cos(((from[1] + to[1]) / 2) * Math.PI / 180));
  const xDelta = longitudeDelta * latitudeScale;
  const distance = Math.hypot(xDelta, latitudeDelta);
  if (distance === 0) return [from, to];
  let perpendicularX = -latitudeDelta / distance;
  let perpendicularY = xDelta / distance;
  if (perpendicularY < 0) {
    perpendicularX *= -1;
    perpendicularY *= -1;
  }
  const bend = Math.min(12, Math.max(0.16, distance * 0.25));
  return Array.from({ length: 17 }, (_, index) => {
    const progress = index / 16;
    const offset = Math.sin(Math.PI * progress) * bend;
    const longitude = from[0] + longitudeDelta * progress
      + (perpendicularX * offset) / latitudeScale;
    const latitude = from[1] + latitudeDelta * progress + perpendicularY * offset;
    return [((longitude + 540) % 360) - 180, Math.max(-85, Math.min(85, latitude))];
  });
}
